/**
 * Common handling method for element outside click
 * @param {*} elem | jQuery element
 * @param {*} callback | callable
 */
 function hideOnClickOutside(elem, callback) {
	var outsideClickListener = function(event) {
		if (!elem.is(event.target) && elem.has(event.target).length === 0) {
			callback();
			removeClickListener();
		}
	}
	var removeClickListener = function() {
		document.removeEventListener('click', outsideClickListener);
	}
	document.addEventListener('click', outsideClickListener);
}


jQuery(document).ready(function() {

    // -------------------
	// Back to top button
	// Show button when scrolled enough
	var amountScrolled = 360;

    jQuery(window).scroll(function() {
		// Scroll to top
		if ( jQuery(window).scrollTop() > amountScrolled ) {
			jQuery('a.scrollToTop').fadeIn('').attr('aria-hidden', false);
		} else {
			jQuery('a.scrollToTop').fadeOut('').attr('aria-hidden', true);
		}

	});
	// Animate page movement
	jQuery('a.scrollToTop').click(function() {
		jQuery('html, body').animate({
			scrollTop: 0
		}, 200);
		jQuery('.quick-access > a').first().focus();
		return false;
	});

	// Language switcher, no translation tooltip
	if( jQuery('.language-switcher').length ) {
		jQuery('.language-switcher .no-translation > a').click(function (e) {
			e.preventDefault();
			jQuery('.language-switcher .no-translation > a').not(jQuery(this)).parents('.language-switcher .no-translation').removeClass('open');
			if(jQuery(this).parent().hasClass('open')){
				jQuery(this).parent().removeClass('open');
			}else{
				jQuery(this).parent().addClass('open');
			}
		});
	}

	/**
	 * Initialize datepicker
	 */
	jQuery('input.datepicker').datepicker({
		dateFormat: 'd.m.yy',
		regional: 'fi'
	});

	/**
	 * Toggle search page sidebar visibility in mobile
	 */
	jQuery(document).on('click', '.mobile-search-tool-toggle', function(e) {
		e.preventDefault();
		var navElement = jQuery('.search-page-sidebar');
		var navOpened = navElement.hasClass('is-active');

		if(navElement.length) {

			if(!navOpened) {
				navElement.addClass('is-active');
				jQuery('.mobile-search-tool-toggle').attr('aria-expanded', true);
				navElement.attr('aria-hidden', false);
				jQuery('input[name="s"]').focus();
				//add overlay
				jQuery('.js-off-canvas-overlay').addClass('is-visible is-closable');
				if(jQuery(navElement).hasClass('mini-search-tools')){
					jQuery(navElement).css('visibility', 'visible');
				}
			} else {
				navElement.removeClass('is-active');
				navElement.attr('aria-hidden', true);
				jQuery('.mobile-search-tool-toggle').attr('aria-expanded', false);
				jQuery('.search-results-anchor').focus();
				jQuery('.js-off-canvas-overlay').removeClass('is-visible is-closable');
				if(jQuery(navElement).hasClass('mini-search-tools')){
					jQuery(navElement).css('visibility', 'hidden');
				}
			}
		}
	});

	//Hide search nav when clicked outside
	document.addEventListener('click', function(e) {
		navElement = jQuery('.search-page-sidebar');
		navButton = jQuery('.mobile-search-tool-toggle');
		navButtonText = jQuery('.mobile-search-tool-toggle-text');

		if(navElement.hasClass('is-active')) {
			if ( (!navElement.is(event.target) && navElement.has(event.target).length === 0) &&
			!navButton.is(event.target) && !navButtonText.is(event.target) ) {
				navElement.removeClass('is-active');
				navElement.attr('aria-hidden', true);
				jQuery(this).attr('aria-expanded', false);
				jQuery('.mobile-search-tool-toggle').attr('aria-expanded', false);
				jQuery('.search-results-anchor').focus();
				jQuery('.js-off-canvas-overlay').removeClass('is-visible is-closable');
				if(jQuery(navElement).hasClass('mini-search-tools')){
					jQuery(navElement).css('visibility', 'hidden');
				}
			}
		}
	});




	// Forms input label
	jQuery('.gfield input, .gfield textarea').focus(function(){
		jQuery(this).parents('.label-inside').addClass('focused');
	});
	jQuery('input, textarea').blur(function(){
		var inputValue = jQuery(this).val();

		if( inputValue == "" ){
	    	jQuery(this).removeClass('filled');
	    	jQuery(this).parents('.gfield').removeClass('focused');
	  	}
		else{
	    	jQuery(this).addClass('filled');
	  	}
	});

	// Custom styling for Gforms
	// Label-inside , styled to show label inside the input field
	if( jQuery('.main .gform_fields').length > 0 ){
		jQuery('.main .gform_fields input[type="text"], .gform_fields textarea').closest('li.gfield').addClass('label-inside');
	}


	// Filters toggle in mobile
	jQuery('.filters-toggle').click(function(){
		var tabContent = jQuery(this).parent().find('.tabs-content');
		//console.log(tabContent);

		if( !tabContent.hasClass('open') ){
			tabContent.addClass('open');
		}
		else{
			tabContent.removeClass('open');
		}

		jQuery('.filters-toggle').removeClass('hidden');
		jQuery(this).addClass('hidden');
	});


	// Tabs in mobile
	jQuery('.tabs-toggle').click(function(){
		var tabContent = jQuery(this).next('ul.tabs');

		jQuery('.tabs-toggle').hide();

		if( !tabContent.hasClass('open') ){
			tabContent.addClass('open');
		}
		else{
			tabContent.removeClass('open');
		}
	});

	if( jQuery('.tabs-toggle').length > 0 ){
		var activeElement = jQuery('.tabs .is-active a').html();

		jQuery('.tabs-toggle').children('span').html(activeElement);
		// jQuery('.tabs li.is-active').addClass('hide-mobile');
	}

	jQuery('.tabs a').click(function(){
		// update fragments of tab titles to url according translations
		for (var i = 0; i < this.attributes.length; i++) {
			var attrib = this.attributes[i];
			if(attrib.name.indexOf("data-language") !== -1){
				var lang = attrib.name.split("_");
				lang = lang[1];

				if(jQuery(".language-switcher a[hreflang='"+lang+"']").length){
					var url_orig = jQuery(".language-switcher a[hreflang='"+lang+"']").attr("href");
					var url_ob = new URL(url_orig);
					url_ob.hash = "#" + attrib.value;
					var new_url = url_ob.href;

					// change the current url
					jQuery(".language-switcher a[hreflang='"+lang+"']").attr("href", new_url);
				}
			}
		}

		var tabContent = jQuery(this).closest('ul.tabs');
		var tabText = jQuery(this).html();

		if( tabContent.hasClass('open') ){
			tabContent.removeClass('open');
			jQuery(this).closest('ul').prev().children('span').html(tabText);

			jQuery('.tabs-toggle').show();
		}
	});


	// Search box toggles - mobile
	jQuery('.searchbox-icon.toggle-search').click(function(){
		jQuery(this).next('.site-search').toggleClass('open');
	});

	jQuery('.searchbox-icon.toggle-search.show-for-small-only').click(function(){
		var sitesearchMobile = '.mobile-navigation .site-search';
		if( !jQuery(sitesearchMobile).hasClass('open') ){
			jQuery(sitesearchMobile).addClass('open');
		}
		setTimeout(function() {
			jQuery(sitesearchMobile).find('input.searchbox-input').focus();
		}, 500);
	});


	// Main navigation
	//Prevent main menu link behavior on 1st level
	var submenuParent = jQuery('.main-navigation > li.menu-item-has-children > a');
	jQuery(submenuParent).click(function(e){
		submenuParent.attr('aria-expanded', function(index, attr){
			return attr == 'false' ? 'true' : 'false';
		});

		submenuParent.not(this).attr('aria-expanded', 'false');
		submenuParent.not(this).next('.submenu').removeClass('js-dropdown-active');
		jQuery(this).next('.submenu').toggleClass('js-dropdown-active');
		e.preventDefault();
	});

	// Mobile navigation
	//Add aria-expanded for opened menuitems and prevent menuitem with children to open link
	var submenuParentMobile = jQuery('#mobile-navigation  li.menu-item-has-children  a');
	jQuery(submenuParentMobile).click(function(e){
		jQuery(this).attr('aria-expanded', function(index, attr){
			return attr == 'false' ? 'true' : 'false';
		});

		jQuery(this).next('.submenu').toggleClass('js-dropdown-active');

		if (jQuery(this).parent().hasClass('is-accordion-submenu-parent')) {
			e.preventDefault();
		}

	});

	jQuery('.main-navigation > li.menu-item-has-children > a, #menu-paanavigaatio > li.menu-item-has-children > a').each(function( index ) {
		jQuery(this).attr({'aria-haspopup': 'true', 'aria-expanded': 'false'})
		jQuery(this).next('ul').addClass('first-sub');
		jQuery(this).closest('li').addClass('is-dropdown-submenu-parent');
	});

	// nav hover
	var megaMenu = jQuery('.main-navigation');
	jQuery(' > .is-dropdown-submenu-parent', megaMenu).each(function () {
		var dropdown = jQuery('.submenu', jQuery(this)[0]);

	  	jQuery('.main-navigation .is-dropdown-submenu-parent').mouseenter(function(){
			jQuery(dropdown).removeClass('js-dropdown-active');
			submenuParent.attr('aria-expanded', 'false');

			jQuery(this).children('.submenu').addClass('js-dropdown-active');
			jQuery(this).children('a').attr('aria-expanded','true');

		});

		jQuery('.main-navigation .is-dropdown-submenu-parent').mouseleave(function(){
			if(jQuery("#megamenu-menu:hover").length == 0){
				setTimeout(function () {
					jQuery(dropdown).removeClass('js-dropdown-active');
					submenuParent.attr('aria-expanded', 'false');
		    	}, 150);
	   		}
		});

	});

	// esc key press
	jQuery(document).on('keyup',function(evt) {
    	if (evt.keyCode == 27) {
			// nav
     		jQuery('.submenu').removeClass('js-dropdown-active');
			submenuParent.not(this).attr('aria-expanded', 'false');

			// langugage dialog
			jQuery('.no-translation.open > a').focus();
			jQuery('.no-translation.open').removeClass('open');
    	}
	});


	// Sidebar navigation
    // add toggle button
    if( jQuery('.sidebar-navigation').length > 0){
		jQuery('.sidebar-navigation .menu-item-has-children > a').after('<button class="toggle-submenu" aria-haspopup="true" aria-expanded="false" aria-label="'+vk_misc_strings.show_more+'"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 13.9 13.9" enable-background="new 0 0 13.9 13.9" xml:space="preserve"> <polygon fill="#001D3E" points="7,10.2 1,4.9 2,3.7 7,8.1 12,3.7 13,4.9 "></polygon> </svg></button>');
		jQuery('.current_page_item, .current_page_ancestor').addClass('open');
		jQuery('.sidebar-navigation .open .sub-menu').slideDown('fast');
		jQuery('.sidebar-navigation .open .toggle-submenu').attr('aria-expanded', 'true');
    }

	jQuery('.toggle-submenu').on('tap click', function(){
		var parent = jQuery(this).closest('li')
		if(!parent.hasClass('open')){
			parent.addClass('open');
			jQuery(this).next('.sub-menu').slideDown('fast');
			jQuery(this).attr('aria-expanded', 'true');
			jQuery(this).attr('aria-label', vk_misc_strings.show_less);
		}
		else{
			parent.removeClass('open');
			jQuery(this).next('.sub-menu').slideUp('fast');
			jQuery(this).attr('aria-expanded', 'false');
			jQuery(this).attr('aria-label', vk_misc_strings.show_more);
		}
    });


	// Slick slider
	if( jQuery('.ads .slides').length > 0 ){
		jQuery('.ads .slides').slick({
			dots: false,
			arrows: false,
			infinite: false,
			speed: 300,
			autoplay: true,
        	autoplaySpeed: 5000,
			slidesToShow: 3,
			slidesToScroll: 3,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2
					}
				},
				{
					breakpoint: 640,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		});
	}

	if( jQuery('.sidebar .slides').length > 0 ){
		jQuery('.sidebar .slides').slick({
			dots: true,
			arrows: false,
			infinite: true,
			speed: 300,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
        	autoplaySpeed: 5000
		});
	}


	// Frontpage lower content area with a background image
	var linesWrapperHeight = jQuery('.lines-wrapper .container').height();
	jQuery('.cards').height(linesWrapperHeight);

	jQuery(window).resize(function() {
    	clearTimeout(this.id);
    	this.id = setTimeout(doneResizing, 500);
	});

	function doneResizing(){
		var linesWrapperHeight = jQuery('.lines-wrapper .container').height();
		jQuery('.cards').height(linesWrapperHeight);
	}



	jQuery(document).on('click', '.mce-my_upload_button', upload_image_tinymce);

	function upload_image_tinymce(e) {
		e.preventDefault();
		var $input_field = jQuery('.mce-my_input_image');
		var custom_uploader = wp.media.frames.file_frame = wp.media({
			title: 'Add Image',
			button: {
				text: 'Add Image'
			},
			multiple: false
		});
		custom_uploader.on('select', function() {
			var attachment = custom_uploader.state().get('selection').first().toJSON();
			$input_field.val(attachment.url);
		});
		custom_uploader.open();
	}

	// Responsive iframes
	if (jQuery(".entry-content iframe").length > 0){
		jQuery(".entry-content iframe").each(function( index ) {
			var iframe = jQuery(this);
			if (iframe.attr("height") && iframe.attr("width")){
				var _w = iframe.attr("width");
				var _h = iframe.attr("height");

				//check if value is in pixels
				if ( (_w.indexOf("%") > -1 ) || (_h.indexOf("%") > -1))
					return;

				_w = parseInt(_w, 10);
				_h = parseInt(_h, 10);

				if (_w > 0 && _h > 0){
					var _ar = (_h/_w)*100;
					var _wrapper = jQuery('<div class="responsive-embed" />');
					_wrapper.css("padding-bottom", _ar+"%");
					iframe.wrap(_wrapper);
				}
			}
		})
	}
	// Responsive iframe in accordion
	if( jQuery('.accordion-content iframe').length > 0 ){
		jQuery('.accordion-content iframe').wrap('<div class="iframe-container"></div>');
	}

	// Wrap tables into table-scrollable div
	if( jQuery('.entry-content table').length > 0 ){
		jQuery('.entry-content table').wrap('<div class="table-scrollable"></div>');
	}

	if( jQuery('.accordion table').length > 0 ){
		jQuery('.accordion table').wrap('<div class="table-scrollable"></div>');
	}


	// Detect objectFit support
	if('objectFit' in document.documentElement.style === false) {

	  // assign HTMLCollection with parents of images with objectFit to variable
	  var container = document.getElementsByClassName('article-thumbnail');

	  // Loop through HTMLCollection
	  for(var i = 0; i < container.length; i++) {

	    // Asign image source to variable
	    var imageSource = container[i].querySelector('img').src;

	    // Hide image
	    container[i].querySelector('img').style.display = 'none';

	    // Add background-size: cover
	    container[i].style.backgroundSize = 'cover';

	    // Add background-image: and put image source here
	    container[i].style.backgroundImage = 'url(' + imageSource + ')';

	    // Add background-position: center center
	    container[i].style.backgroundPosition = 'center center';
	  }
	}

	// Share anchor link vie email
	// console.log(document.URL);
	var curURL = String( document.location.href ).replace( "/#", "" );
    jQuery('.regulation-document .entry-content h2, .regulation-document .entry-content h3, .regulation-document .entry-content h4, .regulation-document .entry-content h5').each(function(){

        var anchorlinkId = jQuery(this).attr('id');

        if (typeof anchorlinkId !== typeof undefined && anchorlinkId !== false) {
            jQuery(this).append('<a href="' + curURL + '#' + anchorlinkId + '" class="share-icon-email" title="" aria-label="Email anchor link"></a>');
			// console.log(anchorlinkId);
        }
    });

	jQuery('.share-icon-email').on('click', function (event) {
		event.preventDefault();

	   	var email = '';
	   	var subject = document.getElementsByTagName("title")[0].innerHTML;
	   	var emailBody = jQuery(this).attr('href');
	   	window.location = 'mailto:' + email + '?subject=' + subject + '&body=' +   emailBody;
	 });

	// Footer form toggle
	jQuery('.load-form').click(function(){
		var $button = jQuery(this);
		var form_id = $button.data("fid");
		var url = $button.data("url");

		var btnAriaLabelLoading = "";
		var bodyLang = document.getElementsByTagName('html')[0].getAttribute('lang');;
		if ( bodyLang == "fi"){
			btnAriaLabelLoading = "Ladataan palautelomaketta";
		}else if( bodyLang == "sv-SE"){
			btnAriaLabelLoading = "Laddar feedbackformulär";
		}else{
			btnAriaLabelLoading = "Loading feedbackform";
		}

		if ($button.hasClass("loading"))
			return;

		$button.addClass("loading");
		jQuery('.feedbackform-state').append('<span class="sr-only">'+ btnAriaLabelLoading +'</span>');

		jQuery.get({
			url: vk.ajax_url,
			data: {
				action: 'gf_button_get_form',
				form_id: form_id,
				url: url
			}
		},function(response){
			jQuery('#gf_button_form_container_'+form_id).html(response).fadeIn();
			if(window['gformInitDatepicker']) {gformInitDatepicker();}
			var _target = $button.parents(".feedback");
		}).success(function(){
			toggleForm();
			$button.removeClass("load-form");
			$button.click(toggleForm);

			/* changing input names to allow autocomplete */
			jQuery('.gform_fields input[type="email"]').attr('name', 'email');
			jQuery('.gform_fields input[type="tel"]').attr('name', 'tel');


			// A11y, Update GForm error message to feedbacform-state element
			const mainNode = document.querySelector('.feedback .feedbackform-state + div');
			const arialiveElem = document.querySelector('.feedback .feedbackform-state .sr-only');

			function callback(mutationsList) {
				mutationsList.forEach(mutation => {


					// Validation error
					if (mutation.attributeName === 'class') {
						const containsValidationError = mutation.target.classList.contains('gform_validation_error');

						if(containsValidationError){
							const validationErrorMessage = document.querySelector('.feedback .validation_error');
							const inputValidationMessages = document.querySelectorAll('.feedback .validation_message');

							let srErrorMessage = validationErrorMessage.innerHTML;

							for (i = 0; i < inputValidationMessages.length; i++) {
								srErrorMessage = srErrorMessage + inputValidationMessages[i].innerHTML;
							}

							arialiveElem.innerHTML= srErrorMessage;
						}
					}
				})
			}

			const mutationObserver = new MutationObserver(callback)
			mutationObserver.observe(mainNode, { attributes: true, childList: true, subtree: true })
		});
	});

	// A11y, GForm thank you msg
	jQuery(document).on('gform_confirmation_loaded', function(event, formId){
		const thankYouMessage = document.querySelector('.feedback .gform_confirmation_message').innerHTML;
		document.querySelector('.feedback .feedbackform-state .sr-only').innerHTML = thankYouMessage;
	});


	jQuery(".checkboxradio input").checkboxradio();
	jQuery( ".checkboxradio" ).controlgroup();

	function handleControlGroupChange($input, e){
		if ($input.is(':checked')){
			e.preventDefault();
			e.stopPropagation();
			$input.prop("checked", false).change();
		};
	}
	jQuery(".ui-controlgroup-item").click(function(e){
		var _input = jQuery(this).attr('for');
		var $input = jQuery("#" + _input);
		handleControlGroupChange($input, e);
	});
	jQuery("input").keyup(function(e){
		if(e.keyCode == '32' || e.keyCode == '13'){
			handleControlGroupChange(jQuery(this), e);
		}
	})


	// update fragments of tab titles to url according translations
	var elem = jQuery('.tabs-wrapper a[aria-selected="true"]');
	if(elem.length > 0) {
		var elem = jQuery(elem)[0];
		jQuery.each(elem.attributes, function(i, attrib){
			if(attrib.name.indexOf("data-language") !== -1){
				var lang = attrib.name.split("_");
				lang = lang[1];

				if(jQuery(".language-switcher a[hreflang='"+lang+"']").length){
					var url_orig = jQuery(".language-switcher a[hreflang='"+lang+"']").attr("href");
					var url_ob = new URL(url_orig);
					url_ob.hash = "#" + attrib.value;
					var new_url = url_ob.href;

					// change the current url
					jQuery(".language-switcher a[hreflang='"+lang+"']").attr("href", new_url);
				}
			}
		});
	}
});

if(jQuery('.feedback div.validation_error').length != 0){
	// code that should be run if the validation error exists goes here
	console.log('valid');
}




var selectmenuExtensions ={
	_setAria: function(item){
		var id = this.menuItems.eq( item.index ).attr( "id" );
		this.button.attr( {
			"aria-activedescendant": id
		} );
		this.menu.attr( "aria-activedescendant", id );
	}
};
jQuery.extend(jQuery.ui.selectmenu.prototype, selectmenuExtensions);


// Footer form toggle
function toggleForm(){
	jQuery('.feedback').toggleClass('form-open');
	jQuery('.form-toggle').attr('aria-expanded', function(index, attr){
		return attr == 'false' ? 'true' : 'false';
	});
}


jQuery(document).ready(function() {
	// -------------------
	// Social share keyboard accessibility
	var shareButton = jQuery('.socialmedia-share li i');
	var shareTxt = jQuery('.socialmedia-share .share-txt').text();

	jQuery(shareButton).each(function(){
		var itemLabel = jQuery(this).attr('title');
		jQuery(this).attr(
			{
				'tabindex': '0',
				'aria-label': shareTxt + ' ' + itemLabel
			}
		);
	});

	shareButton.on('keyup',function(evt) {
		if (evt.keyCode == 13) {
			jQuery(this).click();
		}
	});

	// -------------------
	// Focus trap for mobile navigation - tab navigation
	jQuery('.menu-toggle .hamburger, .searchbox-icon.toggle-search.show-for-small-only').click(function(){
		var submenu = jQuery('.mobile-navigation');
		setTimeout(
			function(){
				findInsiders( submenu );
			},
		530);
	});


	// Search box toggles - mobile
	var mobileSearchToggle = jQuery('.mobile-nav-header .searchbox-icon.toggle-search');

	mobileSearchToggle.keypress(function (e) {
		var key = e.which;
		if(key == 13){
			mobileSearchToggle.click();
			// return false;
		}
	});

	mobileSearchToggle.click(function(){
	   var siteSearch = jQuery(this).next('.site-search');
	   siteSearch.toggleClass('open');
	   // jQuery(this).attr('aria-expanded', 'true');
	   siteSearch.children('.searchbox-input').attr('tabindex', '-1');
	   siteSearch.children('.site-search.open .searchbox-input').attr('tabindex', '0').focus();

	   jQuery(this).attr('aria-expanded', function(index, attr){
		   return attr == 'false' ? 'true' : 'false';
	   });
	});

	// Mobile header toggle
	jQuery('.searchbox-icon.toggle-search.show-for-small-only').click(function(){
		var sitesearchMobile = '.mobile-navigation .site-search';
		var sitesearchInputMobile = '.mobile-navigation .searchbox-input';
		if( !jQuery(sitesearchMobile).hasClass('open') ){
			jQuery(sitesearchMobile).addClass('open');
			jQuery(sitesearchInputMobile).attr('tabindex', '0');

			jQuery(mobileSearchToggle).attr('aria-expanded', 'true');
			// jQuery('.searchbox-icon.toggle-search').attr('aria-expanded', 'true');
		}
		else{
		}
		setTimeout(function() {
			jQuery(sitesearchMobile).find('input.searchbox-input').focus();
		}, 540);
	});



});


// Focus trap function
var findInsiders = function(elem) {
	var tabbable = elem.find('select, input, textarea, button, a').filter(':visible');

	var firstTabbable = tabbable.first();
	var lastTabbable = tabbable.last();

	/*set focus on first input*/
	firstTabbable.focus();

	/*redirect last tab to first input*/
	lastTabbable.on('keydown', function (e) {
		if ((e.which === 9 && !e.shiftKey)) {
			e.preventDefault();
			firstTabbable.focus();
		}
	});

	/*redirect first shift+tab to last input*/
	firstTabbable.on('keydown', function (e) {
		if ((e.which === 9 && e.shiftKey)) {
			e.preventDefault();
			lastTabbable.focus();
		}
	});

	/* allow escape key to close insiders div */
	elem.on('keyup', function(e){
		if (e.keyCode === 27 ) {
			elem.hide();
		};
	});
};

/**
 * Prevent js error if RNS is not loaded
 */

if (typeof window.initRns === 'undefined') {
    window.initRns = function() {}
}

/**
 * Return time remaining between current time and endtime parameter
 */
function getTimeRemaining(endtime) {
	const total = endtime - Date.parse(new Date());
	const weeks = Math.floor((total / (1000 * 60 * 60 * 24)) / 7);
	const days = Math.floor((total / (1000 * 60 * 60 * 24)) - (weeks * 7));
	const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
	const minutes = Math.floor((total / 1000 / 60) % 60);
	const seconds = Math.floor((total / 1000) % 60);

	return {
	  total,
	  weeks,
	  days,
	  hours,
	  minutes,
	  seconds
	};
  }

/**
 * Initialize and update countdown clock
 */
function initializeClock(id, endtime) {
	const clock = document.getElementById(id);
	const weeksSpan = clock.querySelector('.weeks');
	const daysSpan = clock.querySelector('.days');
	const hoursSpan = clock.querySelector('.hours');
	const minutesSpan = clock.querySelector('.minutes');
	const secondsSpan = clock.querySelector('.seconds');

	function updateClock() {
	  const t = getTimeRemaining(endtime);

	  weeksSpan.innerHTML = t.weeks;
	  daysSpan.innerHTML = t.days;
	  hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
	  minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
	  secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);

	  if (t.total <= 0) {
		clearInterval(timeinterval);
	  }
	}

	updateClock();
	const timeinterval = setInterval(updateClock, 1000);
}

/**
 * Service page- customer service accordion
 */
jQuery(document).ready(function(){
	var showElementsCount = jQuery('#sidebar .customer-service').data('show_count');
	var customerServiceElements = jQuery('.service-template-default.single-service .customer-service li');
	var elementsCount = customerServiceElements.length;
	var showMoreButton = jQuery('.customer-service-button');
	var additionalElements = jQuery('.additional-information');
	if(showElementsCount != 0 && elementsCount > showElementsCount){
		jQuery(customerServiceElements).each(function(i, obj){
			if(i > showElementsCount - 1){
				jQuery(additionalElements).append(this);
			}
		});
		jQuery(showMoreButton).show().click(function() {
			additionalElements.slideToggle(400);
			jQuery(this).toggleClass('expanded');
			var expanded = jQuery(this).attr('aria-expanded');
			if(expanded == 'true'){
				jQuery(this).attr('aria-expanded', false);
			}else{
				jQuery(this).attr('aria-expanded', true);
			}
			return false;
		});
	}
});

//On servicechannel page highlight item if url hash points to it
jQuery(function(){
	var hash = window.location.hash.substring(1);
	if(hash){
		jQuery('.servicechannel-list--item').each(function(){
			var item_hash = jQuery(this).data('hash');
			if(hash == item_hash){
				jQuery(this).addClass('highlighted');
				jQuery(this)[0].scrollIntoView({
					behavior: 'smooth'
				});
			}
		});
	}
});

jQuery(function(){
	jQuery('.dropdown-btn').click(function(){
		var element = jQuery(this);
		jQuery('.dropdown-content').each(function(){
			if(jQuery(this) != element){
				if(jQuery(this).parent().hasClass('show')){
					jQuery(this).parent().removeClass('show');
					jQuery(this).parent().find('.dropdown-btn').attr('aria-expanded', false);
				}
			}
		});
		if(jQuery(this).hasClass('show')){
			jQuery(this).parent().removeClass('show');
			jQuery(this).attr('aria-expanded', false);
		}
		else{
			jQuery(this).parent().addClass('show');
			jQuery(this).attr('aria-expanded', true);
		}
	});
});

jQuery(document).on('click', function(event){
	var element = jQuery(event.target).parent();
	if(!jQuery(event.target).hasClass('dropdown-btn') && !element.hasClass('no-translation') && !element.parent().hasClass('no-translation')){
		jQuery('.dropdown-content').each(function(){
			jQuery(this).find('.no-translation').removeClass('open');
			if(jQuery(this).parent().hasClass('show')){
				jQuery(this).parent().removeClass('show');
				jQuery(this).parent().find('.dropdown-btn').attr('aria-expanded', false);
			}
		});
	}
});

//Homepage page links interactions
jQuery(function(){
	jQuery('#vk-frontpage-page-links').each(function(){
		var scrollContainer = jQuery(this).find('.scroll-container').first()[0];

		// Function to update the visibility of arrows based on scroll position
		// hide arrows if the browser width is less than 800px. Mobile users can scroll the page links by swiping.
		function updateArrows() {
			if (scrollContainer.scrollWidth > scrollContainer.clientWidth && window.innerWidth > 800) {
				jQuery('#vk-frontpage-page-links .arrow').show();
			} else {
				jQuery('#vk-frontpage-page-links .arrow').hide();
			}
			updateScroll();
		}

		// Initial check on page load
		updateArrows();

		// Check whenever scrollContainer width changes
		var resizeObserver = new ResizeObserver(updateArrows);
		resizeObserver.observe(scrollContainer);

		var arrowLeft = jQuery(this).find('.arrow.left').first();
		var arrowRight = jQuery(this).find('.arrow.right').first();

		// Function to update the visibility of arrows based on scroll position
		function updateScroll(){
			if(jQuery(scrollContainer).scrollLeft() == 0){
				jQuery(arrowLeft).css('visibility', 'hidden');
			}else{
				jQuery(arrowLeft).css('visibility', 'visible');
			}
			if(scrollContainer.clientWidth + jQuery(scrollContainer).scrollLeft() >= scrollContainer.scrollWidth - 1){
				jQuery(arrowRight).css('visibility', 'hidden');
			}else{
				jQuery(arrowRight).css('visibility', 'visible');
			}
		}

		// Update arrows on scroll
		jQuery(scrollContainer).scroll(function(){
			updateScroll();
		});

		// Scroll left on arrow click
		jQuery(arrowLeft).click(function() {
			var firstHiddenElement = jQuery(scrollContainer).find('.pages-item').first();
			jQuery(scrollContainer).find('.pages-item').each(function(){
				var left = jQuery(this).position().left;
				var margin = parseInt(jQuery(this).css('margin-left').replace('px', ''));
				var width = jQuery(this).outerWidth();
				if(left < -(margin + width/2)){
					firstHiddenElement = jQuery(this);
				}
			});

			if (firstHiddenElement.length) {
				firstHiddenElement[0].scrollIntoView({
					behavior: 'smooth',
					block: 'nearest'
				});
			}
		});

		// Scroll right on arrow click
		jQuery(arrowRight).click(function() {
			var firstHiddenElement = jQuery(scrollContainer).find('.pages-item').last();
			jQuery(scrollContainer).find('.pages-item').each(function(){
				var left = jQuery(this).position().left;
				var margin = parseInt(jQuery(this).css('margin-left').replace('px', ''));
				var width = jQuery(this).outerWidth();
				if(left + margin + width/2 > scrollContainer.clientWidth){
					firstHiddenElement = jQuery(this);
					return false;
				}
			});

			if (firstHiddenElement.length) {
				firstHiddenElement[0].scrollIntoView({
					behavior: 'smooth',
					block: 'nearest'
				});
			}
		});

		// Ensure smooth scrolling when navigating with keyboard
		jQuery(scrollContainer).find('.pages-item').each(function(){
			jQuery(this).keyup(function(event){
				if(event.keyCode == 9){
					this.scrollIntoView({
						behavior: 'smooth',
						block: 'nearest'
					});
				}
			});
		});
	});
});